import fetch from "../utils/fetch";
// vip列表
export function getLawList(data) {
  return fetch({
    url: '/api/portal/specific_search',
    method: 'post',
    data: data
  });
}